import { apiRequest } from "util/services";

// Sonic Survey → Settings → Question bank: questions the company defines once and links into
// its surveys. Each question comes back with the surveys that link it (used_in).
export const fetchQuestionBank = () => apiRequest("feedback/question-bank", "GET", null, true);

// question: the bank-owned fields (type, text, ratingScale, options, topic…);
// translations: { iso: { text, options } }.
export const createBankQuestion = (question, translations) =>
  apiRequest("feedback/question-bank", "POST", { question, translations }, true);

// Rewrites every survey that links it; answers already given keep their wording.
export const updateBankQuestion = (id, question, translations) =>
  apiRequest(`feedback/question-bank/${id}`, "PUT", { question, translations }, true);

// Linked surveys keep a copy of the question.
export const deleteBankQuestion = (id) => apiRequest(`feedback/question-bank/${id}`, "DELETE", null, true);
